var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddToCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0C3.84375 0 4.15625 0.28125 4.21875 0.625L4.28125 1H17.4062C18.0625 1 18.5625 1.65625 18.375 2.28125L16.6875 8.28125C16.5625 8.71875 16.1875 9 15.7188 9H5.8125L6.09375 10.5H15.75C16.1562 10.5 16.5 10.8438 16.5 11.25C16.5 11.6875 16.1562 12 15.75 12H5.46875C5.125 12 4.8125 11.75 4.75 11.4062L2.875 1.5H1.25C0.8125 1.5 0.5 1.1875 0.5 0.75C0.5 0.34375 0.8125 0 1.25 0H3.5ZM15.3438 7.5L16.75 2.5H4.59375L5.53125 7.5H15.3438ZM4.5 14.5C4.5 13.6875 5.15625 13 6 13C6.8125 13 7.5 13.6875 7.5 14.5C7.5 15.3438 6.8125 16 6 16C5.15625 16 4.5 15.3438 4.5 14.5ZM16.5 14.5C16.5 15.3438 15.8125 16 15 16C14.1562 16 13.5 15.3438 13.5 14.5C13.5 13.6875 14.1562 13 15 13C15.8125 13 16.5 13.6875 16.5 14.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToCart);
export default __webpack_public_path__ + "static/media/AddToCart.a0805de7f6b0e360fe63fe7428f8b4f9.svg";
export { ForwardRef as ReactComponent };